var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEarRingL3 = function SvgEarRingL3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 28,
    height: 30,
    viewBox: "0 0 0.61 0.66",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".str0{stroke:#000;stroke-width:.11;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256}.fil0{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2313168580976"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.53.14C.47.04.24 0 .16.17m-.03.2c0 .11.03.2.19.23.06.02.22.02.24-.06M.29.26C.36.23.51.31.4.35.33.37.33.42.44.42c.01 0 .03.01.04.02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.1.21C.01.27.13.36.16.26.17.23.15.23.13.21H.1zM0 .27C0 .23.01.19.06.16.08.15.1.14.12.14c.01.01.03.01.04.02h.01C.21.18.25.2.23.28.21.34.17.36.13.37.1.37.07.37.05.35.02.33.01.3 0 .27z",
    fill: "#000"
  })))));
};

export default SvgEarRingL3;